import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pb-40" }
const _hoisted_2 = { class: "text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden" }
const _hoisted_3 = { class: "bg-theme-green px-4 py-2 text-white" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "flex flex-row items-center" }
const _hoisted_6 = { class: "pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg" }
const _hoisted_7 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-3" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-3" }
const _hoisted_11 = { class: "xl:w-6/12 w-full" }
const _hoisted_12 = { class: "input-wrapper" }
const _hoisted_13 = { class: "flex justify-between items-center" }
const _hoisted_14 = { class: "placeholder-white block bg-theme-modal_inner_bg pl-3 w-full focus:outline-0 text-sm text-theme-white border-none" }
const _hoisted_15 = { class: "flex justify-between items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryWithProductModal = _resolveComponent("CategoryWithProductModal")!
  const _component_CategoryWithRecommendationModal = _resolveComponent("CategoryWithRecommendationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "font-bold tracking-wider leading-tight text-2xl mt-0" }, " New Category ", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveFeaturedCategory && _ctx.saveFeaturedCategory(...args))),
                class: "uppercase hover:bg-slate-100 px-[14px] py-[10px] bg-white rounded text-sm ml-3 tracking-widest text-theme-green"
              }, " save "),
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeAdd && _ctx.closeAdd(...args)), ["prevent"])),
                class: "cursor-pointer rounded-md text-white py-2 pl-2 hover:opacity-70"
              }, "CLOSE")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass('input-wrapper ' + (_ctx.form.name.error_type))
            }, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "text-xs mb-1" }, "Name", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.name.value) = $event)),
                onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateFields(['name']))),
                placeholder: "Dried Flower",
                class: "placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white h-10",
                type: "text"
              }, null, 544), [
                [_vModelText, _ctx.form.name.value]
              ]),
              (_ctx.form.name.error_message)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "field-error label-text mt-1",
                    textContent: _toDisplayString(_ctx.form.name.error_message)
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-xs mb-1" }, "Category Items", -1)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.selectedPids?_ctx.selectedPids.length:0) + " items selected", 1),
                _createElementVNode("div", _hoisted_15, [
                  _cache[8] || (_cache[8] = _createElementVNode("svg", {
                    width: "28",
                    height: "22",
                    class: "mr-4",
                    viewBox: "0 0 28 22",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M8.58268 21.0993L7.18268 19.6993L9.31602 17.4993C6.87157 17.4993 4.77713 16.666 3.03268 14.9993C1.28824 13.3327 0.416016 11.2771 0.416016 8.83268C0.416016 6.4549 1.24379 4.41602 2.89935 2.71602C4.5549 1.01602 6.57157 0.166016 8.94935 0.166016H14.016V2.16602H8.94935C7.12713 2.16602 5.58268 2.81602 4.31602 4.11602C3.04935 5.41602 2.41602 6.98824 2.41602 8.83268C2.41602 10.7216 3.11046 12.3049 4.49935 13.5827C5.88824 14.8605 7.54935 15.4993 9.48268 15.4993L7.28268 13.2993L8.68268 11.8993L13.216 16.466L8.58268 21.0993ZM16.816 17.4993V15.4993H27.0827V17.4993H16.816ZM16.816 9.83268V7.83268H27.0827V9.83268H16.816ZM16.016 2.16602V0.166016H27.0827V2.16602H16.016Z",
                      fill: "#2BA66B"
                    })
                  ], -1)),
                  _createElementVNode("a", {
                    href: "#",
                    class: "bg-white p-2 rounded hover:bg-slate-300",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.showCategoryWithProductModal('catProd')), ["prevent"]))
                  }, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("svg", {
                      width: "25",
                      height: "25",
                      viewBox: "0 0 25 25",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M6.3 19.1508L2.75 15.6008L3.8 14.5508L6.3 17.0258L10.775 12.5508L11.825 13.6258L6.3 19.1508ZM6.3 11.1508L2.75 7.60078L3.8 6.55078L6.3 9.02578L10.775 4.55078L11.825 5.62578L6.3 11.1508ZM13.75 17.2508V15.7508H22.75V17.2508H13.75ZM13.75 9.25078V7.75078H22.75V9.25078H13.75Z",
                        fill: "#2BA66B"
                      })
                    ], -1)
                  ]))])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.categoryWithproductObj.type=='catProd' && _ctx.categoryWithproductObj.active)
      ? (_openBlock(), _createBlock(_component_CategoryWithProductModal, {
          key: 0,
          showProductOnly: true,
          existingproducts: _ctx.selectedPids,
          closeClick: _ctx.closeCategoryWithProductModal,
          actionClick: _ctx.setCategoriesWithProduct
        }, null, 8, ["existingproducts", "closeClick", "actionClick"]))
      : _createCommentVNode("", true),
    (_ctx.categoryWithproductObj.type=='catRecommend' && _ctx.categoryWithproductObj.active)
      ? (_openBlock(), _createBlock(_component_CategoryWithRecommendationModal, {
          key: 1,
          existingproducts: _ctx.selectedPids,
          closeClick: _ctx.closeCategoryWithProductModal,
          actionClick: _ctx.setCategoriesWithProduct
        }, null, 8, ["existingproducts", "closeClick", "actionClick"]))
      : _createCommentVNode("", true)
  ], 64))
}